import React from 'react';
import Card from "@material-ui/core/Card";
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import {withStyles} from '@material-ui/core/styles';
import {estimatedHours} from "../utilities";
import {connect} from "react-redux";
import PageLoader from "./PageLoader";
import {Link} from "react-router-dom";
import StatusChip from "./StatusChip";
import ButtonBase from '@material-ui/core/ButtonBase';
import iconWage from '../assets/images/icon-wage.png';
import iconClock from '../assets/images/icon-clock.png';
import iconProFound from '../assets/images/icon-pro-found.png';
import iconViews from '../assets/images/icon-views.png';


function ShiftCard(props) {
  const {classes} = props;

  if (!props.jobs) return <PageLoader/>;

  const shift = props.shift;
  const job = props.jobs.find(job => job.id === shift.job);

  return (
    <ButtonBase className={classes.button}>
      <Link to={'/' + props.business.slug + '/shifts/' + shift.id}
            style={{textDecoration: 'none', display: 'block', width: '100%', outline: 'none'}}>
        <Card className={classes.card}>
          <CardContent style={{paddingBottom: '18px'}}>
            <div className={classes.summary}>
              <div className={classes.header}>
                <Typography variant='title' className={classes.title}>
                  {job.name}
                </Typography>
                <Typography variant='subheading'>
                  {moment(shift.start_time).format('ddd, D[/]M [at] h:mmA')}
                </Typography>
              </div>
              <StatusChip shift={shift}/>
            </div>
            <div className={classes.details}>
              <div className={classes.detail}>
                <img className={classes.detailIcon} src={iconWage}/>
                <Typography className={classes.detailText} variant={'caption'}>
                  ${shift.wage}
                </Typography>
              </div>
              <div className={classes.detail}>
                <img className={classes.detailIcon} src={iconClock}/>
                <Typography className={classes.detailText} variant={'caption'}>
                  {estimatedHours(moment(shift.start_time), moment(shift.end_time), true)} hours
                </Typography>
              </div>
              <div className={classes.detail}>
                <img className={classes.detailIcon} src={iconProFound}/>
                <Typography className={classes.detailText} variant={'caption'}>
                  {shift.confirmed_pros.length}/{shift.required_pros}
                </Typography>
              </div>
            </div>
          </CardContent>
        </Card>
      </Link>
    </ButtonBase>
  )
}

const mapStateToProps = (state) => ({
  jobs: state.jobs.items,
  business: state.business.item
});

const styles = (theme) => ({
  button: {
    justifyContent: 'stretch',
    width: '100%',
  },
  header: {
    textAlign: 'left',
    flexGrow: 1
  },
  card: {
    height: '100%',
    width: '100%',
    boxShadow: 'none',
    border: `1px solid ${theme.palette.secondary.dark}`,
    borderRadius: '5px',
  },
  summary: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: '8px'
  },
  details: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  detail: {
    flex: 1,
    textAlign: 'left',
  },
  detailIcon: {
    width: '24px',
    height: '24px',
    paddingRight: '2px',
  },
  detailText: {
    display: 'inline',
  },
  title: {
    marginBottom: '4px'
  },
});

export default connect(mapStateToProps)(withStyles(styles)(ShiftCard));



// WEBPACK FOOTER //
// ./src/parts/ShiftCard.js